import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/FbAd.vue')
  },
  {
    path: '/whatsapp',
    name: 'WhatsApp',
    component: () => import('../views/WhatsApp.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
